import { render, staticRenderFns } from "./TagSettings.vue?vue&type=template&id=e4cb2cc6&scoped=true&"
import script from "./TagSettings.vue?vue&type=script&lang=js&"
export * from "./TagSettings.vue?vue&type=script&lang=js&"
import style0 from "./TagSettings.vue?vue&type=style&index=0&id=e4cb2cc6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cb2cc6",
  null
  
)

export default component.exports